import { Pipe, PipeTransform } from '@angular/core';
import { Util } from '../../util/util';

@Pipe({
    name: 'constructUrl',
    standalone: false
})
export class ConstructUrlPipe implements PipeTransform {

  constructor(private util: Util) { }

  transform(value: string, contactLink: string): unknown {

    const contactUrl: URL = new URL(contactLink);
    contactUrl.searchParams.append('c', this.util.getCountry().toLowerCase());
    contactUrl.searchParams.append('lang', this.util.getLanguage().toLowerCase());
    const contactMessageRegex = /\[(.*?)\]/gi;
    const aTagEleReplace = `<a href="${contactUrl}" role="link" target="_blank">$1</a>`;

    return value.replace(contactMessageRegex, aTagEleReplace);
  }

}
